import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DeferredToastService } from 'src/app/services/deferred-toast.service';
import { MeterImage } from 'src/app/models/meter.model';
import {
  BuildingDevelopmentStage,
  BuildingSave,
  BuildingStructure,
  EditBuilding,
} from 'src/app/models/building.model';
import { EntityType, ImageType } from 'src/app/models/image.model';
import { PermissionsEnum } from 'src/app/models/role.model';
import { User } from 'src/app/models/user.model';
import { BuildingService } from 'src/app/services/building.service';
import { UserService } from 'src/app/services/user.service';
import { TranslationService } from 'src/app/services/translation.service';
import {
  AcLineSegmentService,
  AttributeValue,
  AuthService,
  CimSubstationService,
  DmcService,
  EditedAttributeValues,
  EmcOptions,
  EntityModelCustomizationService,
  PermissionsService,
  Purpose,
  SectionDefinitionEntityType,
  SectionInstance,
  getAttributeEdit,
  slideToggle,
} from 'shared-lib';
import { DtService } from 'src/app/services/dt.service';
import { F11Crud } from 'src/app/models/feeder11.model';
import { F33Crud } from 'src/app/models/feeder33.model';
import { F33Service } from 'src/app/services/f33.service';
import { F11Service } from 'src/app/services/f11.service';
import { RecallType } from 'src/app/models/recallType.model';
import { AssetStatusEnum } from 'src/app/models/assetStatus.model';
import { OptionObj } from 'src/app/models/util.model';
import { FeederType } from '../../../models/feeder.model';
import { BlobStorageService } from 'src/app/_modules/shared/_services/blob-storage.service';
import { ContainerNames } from 'src/app/models/containerNames.model';

type BuildingStaticProperty =
  | 'Address'
  | 'ClosestLandmark'
  | 'BuildingOwner'
  | 'BuildingStructure'
  | 'BuildingDevelopmentStage'
  | 'FeederName'
  | 'DtName'
  | 'FrontViewPictures'
  | 'BuildingTagMountedPicture';

@Component({
  selector: 'app-edit-dynamic-building',
  templateUrl: './edit-dynamic-building.component.html',
  styleUrls: ['./edit-dynamic-building.component.scss'],
  animations: [slideToggle],
})
export class EditDynamicBuildingComponent implements OnInit {
  @ViewChild('dropdownContainer') dropdownContainer: ElementRef;
  @ViewChild('closeAudit') auditReviewModal: ElementRef;
  @ViewChild('closeReviewModal') closeReviewModal: ElementRef;

  AssetAssignType = AssetStatusEnum;
  assetAssignType: AssetStatusEnum;

  public PermissionsEnum = PermissionsEnum;

  editEnabled: boolean = false;
  guid: string = '';
  selectedBuilding: EditBuilding = new EditBuilding();
  sectionInstances: SectionInstance[] = [];
  editableAttributeIds: number[] = [];
  editableStaticProperties: string[] = [];
  editedValues: EditedAttributeValues = {};
  buildingInfoCardExpanded: boolean = true;
  connectedAccountsCardExpanded: boolean = true;
  meterInfoCardExpanded: boolean = true;
  userActivityCardExpanded: boolean = true;
  imagesCardExpanded: boolean = true;
  mapLatitude?: number;
  mapLongitude?: number;
  mobileUsers: User[] = [];

  buildingImage: File | null;
  selectedImage: any;
  isImageMapVisible: boolean = false;
  ImageType = ImageType;
  EntityType = EntityType;
  updateStatusDisabled = false;
  fieldAuditDisabled = false;
  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');

  @ViewChild('closeModal') closeModal: ElementRef;
  @ViewChild('closeDQModal') closeDQModal: ElementRef;

  @ViewChild('userFilterInput') userFilter: ElementRef;

  filterText: string = '';
  isDropdownOpened: boolean = false;
  filteredMobileUsers: User[] = [];
  tempAssignedUserId: number = 0;
  imgElement: any;
  imgZoomFullContainer: any;
  currentRotation: number = 0;
  isGhanaPostFieldsVisible: boolean = true;
  isMapVisible: boolean = false;
  f11Options: F11Crud[] = [];
  f33Options: F33Crud[] = [];
  dtOptions: OptionObj[] = [];
  structureOptions: OptionObj[] = [];
  developmentStageOptions: OptionObj[] = [];
  structure = BuildingStructure;
  developmentStage = BuildingDevelopmentStage;
  editFieldsPopulated: boolean = false;
  showRecallMenu: boolean = false;
  recallAssignedAllowed: boolean = false;
  recallValidatedAllowed: boolean = false;
  modalRejectionReason?: string = '';
  isDataQuality: boolean = false;
  isPropertyCodeShort: boolean = true;
  isElectricalAddressLong: boolean = false;
  isCinEnabled: boolean = localStorage.getItem('defaultCaimsCodePatterns') === 'false';

  acLines: any[] = [];
  substations: any[] = [];
  selectableSubstations: any[] = [];
  selectedAcLineId: number = 0;

  timeZone: any;

  constructor(
    private buildingService: BuildingService,
    private dtService: DtService,
    private toastr: ToastrService,
    private deferredToastService: DeferredToastService,
    private route: ActivatedRoute,
    private f33Service: F33Service,
    private f11Service: F11Service,
    public permissionsService: PermissionsService,
    private router: Router,
    private userService: UserService,
    private translationService: TranslationService,
    private el: ElementRef,
    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    private blobStorageService: BlobStorageService,
    public authService: AuthService,
    private cimSubstationService: CimSubstationService,
    private acLineSegmentService: AcLineSegmentService,
    private emcService: EntityModelCustomizationService,
    private dmcService: DmcService
  ) {}

  ngOnInit(): void {
    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.blobStorageService.setContainer(ContainerNames.Images);
    this.guid = this.route.snapshot.paramMap.get('guid') || '';
    this.isDataQuality =
      this.activatedRoute.snapshot.url[0].path == 'data-quality';

    this.imgElement = this.el?.nativeElement?.querySelector(
      '.ngxImageZoomThumbnail'
    );
    this.imgZoomFullContainer =
      this.el?.nativeElement?.querySelector('.ngxImageZoomFull');
    this.getSelectedBuilding(this.guid);
    this.getSectionInstances(this.guid);
    this.getEditEmcOptions();
    this.setFieldsVisibility();
    this.deferredToastService.showQueuedMessage();
  }

  setModalType(type: AssetStatusEnum) {
    this.assetAssignType = type;
  }

  checkFieldAuditDisable() {
    if (
      this.selectedBuilding.connectedCustomers != null &&
      this.selectedBuilding.connectedCustomers.length > 0
    ) {
      this.fieldAuditDisabled =
        this.selectedBuilding.connectedCustomers.filter(
          (x) => x.isAudited == false
        ).length > 0;
    }
  }

  assignTask(): void {
    if (
      this.mobileUsers.filter((x) => x.fullName == this.filterText.trim())
        .length > 0
    ) {
      this.selectedBuilding.assignedUserId = this.mobileUsers.filter(
        (x) => x.fullName == this.filterText.trim()
      )[0].id;
      this.tempAssignedUserId = this.selectedBuilding.assignedUserId;
    } else {
      this.tempAssignedUserId = 0;
    }
    if (this.tempAssignedUserId != 0) {
      this.buildingService
        .assignBuilding(
          this.selectedBuilding.id,
          this.selectedBuilding.assignedUserId,
          this.assetAssignType,
          this.isDataQuality
        )
        .subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.closeModal?.nativeElement?.click();
              this.deferredToastService.queueSuccess('Successfully assigned user');
              window.location.reload();
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured');
          },
        });
    } else {
      this.toastr.warning('Please select valid user.');
    }
  }
  checkUpdateStatusDisable(id: number) {
    this.buildingService.getConnectedCustomersDataQualityStatus(id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
           this.updateStatusDisabled = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  getSelectedBuilding(guid: string) {
    this.buildingService.getByGuid(guid).subscribe({
      next: (data) => {

        this.selectedBuilding = new EditBuilding(data?.body?.data);
        this.checkUpdateStatusDisable(this.selectedBuilding.id);
        this.filterText = this.selectedBuilding.assignedUser;
        this.tempAssignedUserId = this.selectedBuilding.assignedUserId;
        this.selectedBuilding.feederId = this.selectedBuilding.dt?.feeder?.id;
        this.selectedBuilding.dtId = this.selectedBuilding.dt
          ? this.selectedBuilding.dt.id
          : 0;

        if (
          this.permissionsService.isBuildingRecallAssignedAllowed &&
          !(
            this.selectedBuilding.dataQualityStatus?.toString() != 'Rejected' &&
            this.selectedBuilding.status != 'Assigned'
          )
        ) {
          this.recallAssignedAllowed = true;
        }

        if (
          this.permissionsService.isBuildingRecallValidatedAllowed &&
          this.selectedBuilding.dataQualityStatus
        ) {
          this.recallValidatedAllowed = true;
        }

        if (
          this.selectedBuilding.dataValidationReview != null &&
          this.selectedBuilding.dataValidationReview.length > 0
        ) {
          this.modalRejectionReason =
            this.selectedBuilding.dataValidationReview.find(
              (x) => x.key == 'Reason for rejection'
            )?.value;
        }
        this.checkFieldAuditDisable();
      },
      error: (error) => {
        this.toastr.error('An error ocurred.');
      },
    });
  }

  getSectionInstances(guid: string) {
    this.buildingService.getSectionInstances(guid).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.sectionInstances = (responseData.data ?? []).map((section) => ({
            ...section,
            expanded: true,
          }));
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: () => {
        this.toastr.error('Error fetching section instances');
      },
    });
  }

  private getEditEmcOptions() {
    const utilityId = parseInt(localStorage.getItem('utilityId') || '0');
    this.emcService
      .getSelectedEmcOptions(SectionDefinitionEntityType.Building, Purpose.Edit, utilityId)
      .subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            const options = (responseData.data ?? []) as EmcOptions[];
            this.editableAttributeIds = options
              .filter((option) => option.attributeDefinitionId)
              .map((option) => option.attributeDefinitionId!);
            this.editableStaticProperties = options
              .filter((option) => option.staticPropertyName)
              .map((option) => option.staticPropertyName!);
          } else {
            this.toastr.error(responseData?.message || 'Failed to fetch EMC options');
          }
        },
        error: () => {
          this.toastr.error('Error occurred while fetching EMC options');
        },
      });
  }

  isStaticEditable(property: BuildingStaticProperty): boolean {
    return this.editEnabled && this.editableStaticProperties.includes(property);
  }

  get isFeederEditable(): boolean {
    return this.isStaticEditable('FeederName') && this.isStaticEditable('DtName');
  }

  showBuildingLocation() {
    this.mapLatitude = this.selectedBuilding.latitude;
    this.mapLongitude = this.selectedBuilding.longitude;
    this.isMapVisible = !this.isMapVisible;
  }

  setClickedLocation(attributeValue: AttributeValue) {
    this.mapLatitude = attributeValue.latitude;
    this.mapLongitude = attributeValue.longitude;
    this.isMapVisible = !this.isMapVisible;
  }

  edit() {
    this.editEnabled = true;
    if (!this.editFieldsPopulated) {
      if (this.authService.hasCimDataIntegration) {
        this.prefillCim();
      } else {
        this.getFeedersForOptions();
        if (this.selectedBuilding?.feederId) {
          this.getDtsForOptions(this.selectedBuilding.feederId);
        }
      }
      this.getBuildingEnums();

      this.editFieldsPopulated = true;
    }
  }

  disableAuditReviewButton() {
    return (
      this.selectedBuilding.auditedStatus === 'Audited' ||
      this.fieldAuditDisabled
    );
  }

  disableReviewButton() {
    return (
      this.selectedBuilding.reviewStatus === 'Reviewed' ||
      !this.selectedBuilding.dataQualityStatus
    );
  }

  cancel() {
    this.auditReviewModal?.nativeElement?.click();
  }

  cancelReviewModal(event: any) {
    this.closeReviewModal?.nativeElement?.click();
  }

  selectOption(e: any) {
    this.selectedBuilding.assignedUserId = +e.target.value;
  }

  save() {
    if (
      (this.isStaticEditable('ClosestLandmark') && !this.selectedBuilding.closestLandmark) ||
      (this.isStaticEditable('BuildingOwner') && !this.selectedBuilding.buildingOwner)
    ) {
      this.toastr.error(
        'Closest landmark and building owner can not be empty!'
      );
      return;
    }
    if (this.isStaticEditable('DtName')) {
      if (this.authService.hasCimDataIntegration) {
        if (!this.selectedBuilding.substationId) {
          this.toastr.error('DT name can not be empty!');
          return;
        }
      } else if (!this.selectedBuilding.dtId) {
        this.toastr.error('DT name can not be empty!');
        return;
      }
    }

    let saveModel = new BuildingSave();
    saveModel.closestLandmark = this.selectedBuilding.closestLandmark;
    saveModel.buildingOwner = this.selectedBuilding.buildingOwner;
    saveModel.id = this.selectedBuilding.id;
    saveModel.assignedUserId = this.selectedBuilding.assignedUserId;
    saveModel.buildingDevelopmentStage =
      this.selectedBuilding.buildingDevelopmentStage;
    saveModel.buildingStructure = this.selectedBuilding.buildingStructure;
    saveModel.dtId = this.selectedBuilding.dtId;
    saveModel.substationId = this.selectedBuilding.substationId || null;
    saveModel.address = this.selectedBuilding.address;

    const attributeEdit = getAttributeEdit(this.sectionInstances, this.editableAttributeIds, this.editedValues);
    if (attributeEdit.invalid) {
      this.toastr.warning('Please correct the invalid fields.');
      return;
    }

    if (attributeEdit.changed.length === 0) {
      this.saveBuilding(saveModel);
      return;
    }

    this.dmcService
      .updateAttributeValues({
        assetType: SectionDefinitionEntityType.Building,
        assetGuid: this.guid,
        attributeValues: attributeEdit.changed,
      })
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.saveBuilding(saveModel);
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
  }

  private saveBuilding(saveModel: BuildingSave) {
    this.buildingService.addOrUpdateBuilding(saveModel).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.editEnabled = false;
          this.deferredToastService.queueSuccess('Successfully updated record. Status reverted to Pending.');
          window.location.reload();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  getMobileUsers() {
    const regionId = this.authService.hasCimDataIntegration
      ? this.selectedBuilding.subgeographicalRegionId
      : this.selectedBuilding.areaId;
    this.userService
      .getMobileUsers(regionId, this.filterText)
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.mobileUsers = responseData.data;
            if (this.mobileUsers.length == 0) {
              this.isDropdownOpened = false;
            } else {
              this.isDropdownOpened = true;
            }
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
  }

  navigateToCustomer(customer: any) {
    if (customer.isOnboard) {
      window.open(`/customers/edit-onboard/${customer.id}`);
    } else {
      window.open(`/customers/edit/${customer.guid}`);
    }
  }
  getImageByType(imageType: string, index?: number) {
    const images = this.selectedBuilding.images?.filter((x) => x.imageType === imageType);
    return images?.[index ?? 0];
  }

  getBuildingMountedImage() {
    return this.selectedBuilding.images?.find(
      (x) => x.imageType === 'MountedTag'
    )?.url;
  }

  getFrontViewImage(id: number) {
    return (
      this.selectedBuilding.images?.filter((x) => x.imageType === 'Frontview')[
        id
      ]?.url ?? ''
    );
  }

  fileBrowserHandler({ file, type, imageId }: { file: File, type: ImageType, imageId: number }) {
    if (!file) {
      this.toastr.error('Image data is missing');
      return;
    }
  
    this.buildingImage = file;

    this.blobStorageService.uploadFile(
      this.buildingImage,
      this.buildingImage.name,
      (uploadedUrl) => {
        const obj = {
          imageType: type,
          buildingId: this.selectedBuilding.id,
          guid: this.selectedBuilding.guid,
          url: uploadedUrl,
          imageId: imageId,
        };

        this.buildingService.uploadPicture(obj, this.buildingImage!).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              if (imageId != -1) {
                const images = this.selectedBuilding.images.filter(
                  (x) => x.imageType == ImageType[type]
                );
                const imageIndex = this.selectedBuilding.images.indexOf(
                  images[imageId]
                );
                this.selectedBuilding.images[imageIndex] = responseData.data;
              } else this.selectedBuilding.images.push(responseData.data);
              this.toastr.success('Successfully added image');
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occurred while saving image metadata');
          },
        });
      },
      (error) => {
        console.error('Error uploading image to blob storage:', error);
        this.toastr.error('Failed to upload image to storage');
      }
    );
  }
  
  showImage(type: ImageType, num?: number) {
    if (type === ImageType.Frontview) {
      this.selectedImage = this.getImageByType('Frontview', num!);
    } else if (type === ImageType.MountedTag) {
      this.selectedImage = this.getImageByType('MountedTag');
    }
  }
  showInaccessibleImage(image: MeterImage) {
 
    this.selectedImage = image;
  }
  renderMeterStatus() {
    let meteredUsers = this.selectedBuilding.connectedCustomers.filter(
      (x) => x.meterNumber !== ''
    );
    return meteredUsers.length > 0;
  }
  cancelModal() {
    this.closeModal?.nativeElement?.click();
  }

  selectFieldAgent(id: number) {
    this.isDropdownOpened = false;
    this.selectedBuilding.assignedUserId = id;
    this.tempAssignedUserId = id;
    var mobUser = this.mobileUsers.find((x) => x.id == id);
    this.filterText = mobUser!.fullName;
  }

  recallAssigned() {
    this.buildingService
      .recall(this.selectedBuilding.id, RecallType.Assigned)
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.deferredToastService.queueSuccess('Successfully recalled building.');
            window.location.reload();
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
  }

  recallValidation() {
    this.buildingService
      .recall(this.selectedBuilding.id, RecallType.Validated)
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.deferredToastService.queueSuccess(
              "Successfully recalled building's Data Quality."
            );
            window.location.reload();
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
  }

  viewConnectedAssets(type: any) {
    switch (type) {
      case 1:
        this.router.navigate([`poles/edit/${this.selectedBuilding.poleId}`]);
        break;
    }
  }

  filterMobileUsers() {
    this.isDropdownOpened = true;
    this.tempAssignedUserId = 0;
    this.getMobileUsers();
  }
  openDropdown() {
    this.isDropdownOpened = true;
  }

  onModalAssignFade() {
    this.filterText = this.selectedBuilding.assignedUser;
  }

  onModalFade() {
    this.currentRotation = 0;

    if (this.imgZoomFullContainer) {
      var displayValue = getComputedStyle(this.imgZoomFullContainer).display;

      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }
  }

  rotateLeft() {
    this.currentRotation -= 90;
  }

  rotateRight() {
    this.currentRotation += 90;
  }
  closeRedirectModal() {
    this.closeDQModal?.nativeElement?.click();
  }
  onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: MouseEvent) {
    const clickedInside =
      this.isDropdownOpened &&
      (this.dropdownContainer?.nativeElement?.contains(event.target) ||
        this.userFilter?.nativeElement?.contains(event.target));
    if (!clickedInside) {
      this.isDropdownOpened = false;
    }
  }

  setFieldsVisibility() {
    let notVisibleFields: any = localStorage.getItem('notVisibleFields');

    if (!notVisibleFields) {
      return;
    }

    notVisibleFields = JSON.parse(notVisibleFields);
    this.isGhanaPostFieldsVisible = notVisibleFields.find(
      (el: any) => el === 'ghanaPostCode'
    )
      ? false
      : true;
  }

  selectFeeder() {
    this.selectedBuilding.dtId = 0;
    this.getDtsForOptions(this.selectedBuilding.feederId);
  }

  getDtsForOptions(feederId: number) {
    if (
      this.selectedBuilding.dt?.feeder.feederType === FeederType.NOT_SELECTED
    ) {
      return;
    }
    this.dtService
      .getAllForSelectByFeeder(
        feederId,
        this.selectedBuilding.dt?.feeder?.feederType.toString()
      )
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.dtOptions = response.body.data;
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
  }

  private prefillCim() {
    this.selectedAcLineId = this.selectedBuilding.acLineId ?? 0;
    this.getAcLines();
    this.getSubstations();
  }

  getAcLines() {
    this.acLineSegmentService
      .getAllACLinesCached({ voltageClasses: [] })
      .subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.acLines = responseData.data ?? [];
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: () => this.toastr.error('Error occured'),
      });
  }

  getSubstations() {
    this.cimSubstationService
      .getAllSubstationsCached({ voltageClasses: [1] })
      .subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.substations = responseData.data ?? [];
            this.refreshSelectableSubstations();
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: () => this.toastr.error('Error occured'),
      });
  }

  selectAcLine(e: any) {
    this.selectedAcLineId = +e.target.value;
    const line = this.acLines.find((x) => x.id === this.selectedAcLineId);
    this.selectedBuilding.acLineId = this.selectedAcLineId;
    this.selectedBuilding.dt.feeder.number = line?.number ?? '';
    this.selectedBuilding.substationId = 0;
    this.refreshSelectableSubstations();
  }

  selectSubstation(e: any) {
    this.selectedBuilding.substationId = +e.target.value;
  }

  private refreshSelectableSubstations() {
    if (this.selectedAcLineId) {
      this.selectableSubstations = this.substations.filter((s) =>
        (s.incomingACLines ?? []).some((l: any) => l.id === this.selectedAcLineId)
      );
    } else {
      this.selectableSubstations = this.substations;
    }
  }

  getFeedersForOptions() {
    this.f11Service.getAllForSelect().subscribe(
      (response) => {
        this.f11Options = response.body.data;
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );

    this.f33Service.getAllForSelect().subscribe(
      (response) => {
        this.f33Options = response.body.data;
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  switchPropertyCodeFormat() {
    this.isPropertyCodeShort = !this.isPropertyCodeShort;
  }

  switchElectricalAddressFormat() {
    this.isElectricalAddressLong = !this.isElectricalAddressLong;
  }

  getBuildingEnums() {
    Object.values(BuildingStructure)
      .filter((v) => !isNaN(Number(v)))
      .forEach((key) => {
        const optionObject: OptionObj = {
          key: Number(key),
          value: BuildingStructure[key as number],
        };
        this.structureOptions.push(optionObject);
      });

    Object.values(BuildingDevelopmentStage)
      .filter((v) => !isNaN(Number(v)))
      .forEach((key) => {
        const optionObject: OptionObj = {
          key: Number(key),
          value: BuildingDevelopmentStage[key as number],
        };
        this.developmentStageOptions.push(optionObject);
      });
  }
}
